<script setup lang="ts">
import { useAppStore } from "@/store/App";
import OfflineMessage from "@/components/OfflineMessage.vue";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";

defineProps({
  feature: {
    type: String,
    required: false,
  },
  showOffline: {
    type: Boolean,
    default: false,
  },
});

const { isOffline } = storeToRefs(useAppStore());

onMounted(() => {
  const element = document.getElementById("main-wrapper");
  if(element){
    element.scrollTop = 0;
  }
});
</script>
<template>
  <section tabindex="0" class="">
      <div>
        <OfflineMessage :feature="feature" v-if="isOffline && !showOffline"></OfflineMessage>
        <div class="flex flex-col gap-2" v-else>
          <slot></slot>
        </div>
      </div>
  </section>
</template>